module.exports = __webpack_public_path__ + "img/banner4@2x.d529f52f.png";